export const StatsSection = () => {
  const gradients: any = {
    emerald:
      "bg-[linear-gradient(to_bottom_right,rgba(16,185,129,0.2),rgba(16,185,129,0.05))]",
    blue: "bg-[linear-gradient(to_bottom_right,rgba(59,130,246,0.2),rgba(59,130,246,0.05))]",
    amber:
      "bg-[linear-gradient(to_bottom_right,rgba(245,158,11,0.2),rgba(245,158,11,0.05))]",
    purple:
      "bg-[linear-gradient(to_bottom_right,rgba(168,85,247,0.2),rgba(168,85,247,0.05))]",
  };

  return (
    <section className="relative overflow-hidden bg-[linear-gradient(to_bottom,hsl(197_77%_17%),rgba(10,52,74,0.95))] py-14 md:py-20">
      {/* BG Overlay */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(29,171,145,0.1)_0%,transparent_70%)]" />

      <div className="relative mx-auto max-w-[1400px] px-6">
        {/* Header */}
        <div className="mb-10 text-center">
          <p className="text-[14px] font-medium uppercase tracking-wider text-white/60">
            Why Choose FinEase
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4 md:gap-8">
          {[
            {
              title: "SEBI Registered",
              desc: "Fully compliant with SEBI regulations",
              icon: "emerald",
              svg: "/assets/compliant.svg",
            },
            {
              title: "Bank-Grade Security",
              desc: "256-bit SSL encryption",
              icon: "blue",
              svg: "/assets/Lock.svg",
            },
            {
              title: "RBI Compliant",
              desc: "Regulated financial services",
              icon: "amber",
              svg: "/assets/circalStar.svg",
            },
            {
              title: "DICGC Insured",
              desc: "FDs insured up to ₹5 lakh",
              icon: "purple",
              svg: "/assets/circalStar.svg",
            },
          ].map(item => (
            <div
              key={item.title}
              className="group cursor-pointer rounded-2xl border border-white/10 bg-white/5 p-6 text-center text-white/90 backdrop-blur-sm transition-all duration-300 hover:bg-white/10"
            >
              {/* Icon */}
              <div
                className={`mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-xl transition-transform duration-300 group-hover:scale-110 ${gradients[item.icon]}`}
              >
                <img src={item.svg} alt={item.title} width={28} height={28} />
              </div>

              <h4 className="mb-1 text-[16px] font-bold">{item.title}</h4>
              <p className="text-[14px] leading-relaxed text-white/60">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
